'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint-disable react/no-danger */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _antd = require('@adparlor-devops/antd');

var _helpers = require('@adparlor-devops/js-anvil/helpers');

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _ValidationInput = require('./ValidationInput');

var _ValidationInput2 = _interopRequireDefault(_ValidationInput);

var _helpers2 = require('../../../../helpers/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangePicker = _antd.DatePicker.RangePicker;
var Option = _antd.Select.Option;
var RulesetExpanded = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RulesetExpanded, _Component);

  function RulesetExpanded(props) {
    (0, _classCallCheck3.default)(this, RulesetExpanded);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RulesetExpanded.__proto__ || (0, _getPrototypeOf2.default)(RulesetExpanded)).call(this, props));

    _this.editRule = function (id) {
      var ruleEditingIds = _this.state.ruleEditingIds.map(function (editing) {
        return (0, _assign2.default)({}, editing);
      });
      ruleEditingIds.push({ id: id });
      _this.setState({ ruleEditingIds: ruleEditingIds });
    };

    _this.hasValidationErrors = function (bool) {
      _this.setState({
        hasValidationErrors: bool
      });
    };

    _this.updateEditingRule = function (id, value, updatedAttribute) {
      var index = _this.state.ruleEditingIds.findIndex(function (rule) {
        return rule.id === id;
      });
      var ruleEditingIds = _this.state.ruleEditingIds.map(function (rule) {
        return (0, _assign2.default)({}, rule);
      });
      var updatedProps = void 0;

      if (value === "name") updatedProps = { name: updatedAttribute };else if (value === "frequency") updatedProps = { frequency: updatedAttribute };else if (value === "schedule") {
        if (updatedAttribute.length === 0) {
          updatedProps = {
            startTime: null,
            endTime: null
          };
        } else {
          var timezone = _this.props.record.timezone;

          updatedProps = {
            startTime: (0, _helpers2.parseTimeInTimeZone)(updatedAttribute[0], timezone),
            endTime: (0, _helpers2.parseTimeInTimeZone)(updatedAttribute[1], timezone)
          };
        }
      }

      var ruleEdit = (0, _assign2.default)({}, ruleEditingIds[index], updatedProps);
      ruleEditingIds.splice(index, 1, ruleEdit);
      _this.setState({
        ruleEditingIds: ruleEditingIds
      });
      _this.hasValidationErrors(false);
    };

    _this.cancelEditRule = function (id) {
      var ruleEditingIds = _this.state.ruleEditingIds.map(function (editing) {
        return (0, _assign2.default)({}, editing);
      });
      var index = ruleEditingIds.findIndex(function (rule) {
        return rule.id === id;
      });
      if (index !== -1) {
        // Record Found
        ruleEditingIds.splice(index, 1);
        _this.setState({ ruleEditingIds: ruleEditingIds });
      }
    };

    _this.saveEditRule = function (record, updated) {
      var newRecord = (0, _assign2.default)({}, record);
      _this.props.rulesActions('update', { data: newRecord, updated: updated });
      _this.cancelEditRule(newRecord.id);
    };

    _this.toggleDescriptionModal = function (record) {
      _this.setState({
        descriptionModalVisible: !_this.state.descriptionModalVisible,
        descriptionModalRecord: record
      });
    };

    _this.state = {
      ruleEditingIds: [],
      descriptionModalVisible: false,
      hasValidationErrors: false
    };
    return _this;
  }

  (0, _createClass3.default)(RulesetExpanded, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ruleSetId = this.props.record.id;
      var columns = [{
        title: '',
        dataIndex: 'delivery',
        key: 'delivery',
        width: 10,
        render: function render(text, record) {
          return (0, _helpers2.renderDeliveryTableCell)(record);
        }
      }, {
        title: 'Rule Name',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        sorter: function sorter(ruleOne, ruleTwo) {
          var ruleNameOne = ruleOne.name.toLowerCase();
          var ruleNameTwo = ruleTwo.name.toLowerCase();
          if (ruleNameOne < ruleNameTwo) return -1;
          if (ruleNameOne > ruleNameTwo) return 1;
          return 0;
        },
        render: function render(name, record) {
          var isEditing = _this2.state.ruleEditingIds.find(function (rule) {
            return rule.id === record.id;
          });
          if (isEditing) {
            return _react2.default.createElement(_ValidationInput2.default, {
              recordId: record.id,
              name: name,
              onChange: _this2.updateEditingRule,
              hasValidationErrors: _this2.hasValidationErrors
            });
          }
          return _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.toggleDescriptionModal(record);
              } },
            name
          );
        }
      }, {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 80,
        className: "text-align-center",
        sorter: function sorter(ruleOne, ruleTwo) {
          if (ruleOne.status < ruleTwo.status) return -1;
          if (ruleOne.status > ruleTwo.status) return 1;
          return 0;
        },
        render: function render(status, record) {
          var isEditing = _this2.state.ruleEditingIds.find(function (rule) {
            return rule.id === record.id;
          });
          return _react2.default.createElement(_antd.Switch, {
            size: 'small',
            checked: status === 'ACTIVE',
            disabled: typeof isEditing !== 'undefined',
            onChange: function onChange() {
              return _this2.saveEditRule(record, { status: record.status === 'ACTIVE' ? 'PAUSED' : 'ACTIVE' });
            }
          });
        }
      }, {
        title: 'Schedule',
        dataIndex: 'startTime-endTime',
        key: 'startTime-endTime',
        width: 145,
        sorter: function sorter(ruleOne, ruleTwo) {
          var dateOne = (0, _momentTimezone2.default)(ruleOne.startTime);
          var dateTwo = (0, _momentTimezone2.default)(ruleTwo.startTime);
          if (dateOne < dateTwo) return -1;
          if (dateOne > dateTwo) return 1;
          return 0;
        },
        render: function render(text, record) {
          var isEditing = _this2.state.ruleEditingIds.find(function (rule) {
            return rule.id === record.id;
          });
          if (isEditing) {
            var _props$record = _this2.props.record,
                startTime = _props$record.startTime,
                endTime = _props$record.endTime,
                timezone = _props$record.timezone;

            var rulesetStartDateTime = _momentTimezone2.default.tz(startTime, timezone);
            var rulesetEndDateTime = _momentTimezone2.default.tz(endTime, timezone);
            var currentDateTime = (0, _momentTimezone2.default)().tz(timezone);
            var ruleStartTime = record.startTime ? _momentTimezone2.default.tz(record.startTime, timezone) : null;
            var ruleEndTime = record.endTime ? _momentTimezone2.default.tz(record.endTime, timezone) : null;
            var disabledDate = function disabledDate(current) {
              return current && (_momentTimezone2.default.tz(current, timezone).startOf('day').valueOf() > rulesetEndDateTime.startOf('day').valueOf() || _momentTimezone2.default.tz(current, timezone).startOf('day').valueOf() < currentDateTime.startOf('day').valueOf() || _momentTimezone2.default.tz(current, timezone).startOf('day').valueOf() < rulesetStartDateTime.startOf('day').valueOf());
            };
            return _react2.default.createElement(RangePicker, {
              style: { width: 175 },
              defaultValue: [ruleStartTime, ruleEndTime],
              showTime: {
                defaultValue: [(0, _momentTimezone2.default)('00:00:00', 'HH:mm:ss'), (0, _momentTimezone2.default)('23:59:59', 'HH:mm:ss')]
              },
              format: 'MMM-DD-YY',
              disabledDate: disabledDate,
              disabledTime: function disabledTime(selectedDates, type) {
                return (0, _helpers2.disableTimeRange)(selectedDates, type, startTime, endTime, timezone);
              },
              onChange: function onChange(value) {
                if (value && value.length === 0) _this2.updateEditingRule(record.id, "schedule", value);
              },
              onOk: function onOk(value) {
                return _this2.updateEditingRule(record.id, "schedule", value);
              }
            });
          }
          if (!record.startTime && !record.endTime) {
            return _react2.default.createElement(
              'span',
              null,
              'Ongoing'
            );
          }
          var formatter = (0, _helpers.scheduleFormatter)(record.startTime, record.endTime, _this2.props.record.timezone);
          var fullDateRange = (0, _helpers2.dateRangeFormater)(record.startTime, record.endTime, _this2.props.record.timezone);
          return _react2.default.createElement(
            _antd.Tooltip,
            { title: fullDateRange },
            _react2.default.createElement(
              'span',
              null,
              formatter
            )
          );
        }
      }, {
        title: 'Timezone',
        dataIndex: 'timezone',
        key: 'timezone',
        width: 150,
        render: function render() {
          var timezone = _this2.props.record.timezone;

          if (_this2.props.fetchingTimezones) {
            return _react2.default.createElement(_antd.Spin, { size: 'small' });
          }
          var metaTimezone = _this2.props.metaTimezones.find(function (metaTimezone) {
            return timezone === metaTimezone.id;
          });
          return _react2.default.createElement(
            'span',
            null,
            metaTimezone ? metaTimezone.longLabel : timezone
          );
        }
      }, {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'frequency',
        width: 100,
        render: function render(frequency, record) {
          var currentFrequency = _this2.props.frequencies.find(function (freq) {
            return freq.value === frequency;
          });
          var isEditing = _this2.state.ruleEditingIds.find(function (rule) {
            return rule.id === record.id;
          });
          if (isEditing) {
            return _react2.default.createElement(
              _antd.Select,
              {
                defaultValue: currentFrequency.value,
                showSearch: false,
                style: { width: 150 },
                onChange: function onChange(value) {
                  return _this2.updateEditingRule(record.id, "frequency", value);
                }
              },
              _this2.props.frequencies.map(function (frequency) {
                return _react2.default.createElement(
                  Option,
                  { key: frequency.value, value: frequency.value },
                  frequency.label
                );
              })
            );
          }
          return _react2.default.createElement(
            'span',
            null,
            currentFrequency.label
          );
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.lastEvaluatedAt.column', defaultMessage: 'Last Evaluated' }),
        dataIndex: 'lastEvaluatedAt',
        key: 'lastEvaluatedAt',
        width: 105,
        sorter: function sorter(ruleOne, ruleTwo) {
          if (!ruleTwo.lastEvaluatedAt) {
            return 1;
          }
          if (!ruleOne.lastEvaluatedAt) {
            return -1;
          }
          var dateOne = _momentTimezone2.default.tz(ruleOne.lastEvaluatedAt, _this2.props.record.timezone).valueOf();
          var dateTwo = _momentTimezone2.default.tz(ruleTwo.lastEvaluatedAt, _this2.props.record.timezone).valueOf();
          if (dateOne < dateTwo) return -1;
          if (dateOne > dateTwo) return 1;
          return 0;
        },
        render: function render(text, record) {
          return (0, _helpers.lastExecutedAtFormatter)(record.lastEvaluatedAt, _this2.props.record.timezone);
        }
      }, {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        width: 130,
        className: "action-icons",
        render: function render(text, record) {
          if (_this2.props.savingRuleId.includes(record.id)) {
            return _react2.default.createElement(_antd.Spin, null);
          }

          var isEditing = _this2.state.ruleEditingIds.find(function (rule) {
            return rule.id === record.id;
          });
          if (isEditing) {
            var editableProps = ['name', 'frequency', 'endTime', 'startTime'];
            var shouldDisableSave = _this2.state.hasValidationErrors || !editableProps.some(function (prop) {
              return Object.prototype.hasOwnProperty.call(isEditing, prop);
            });
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: shouldDisableSave ? 'disable-cursor' : '' },
                _react2.default.createElement(
                  'a',
                  { disabled: shouldDisableSave, onClick: function onClick() {
                      return _this2.saveEditRule(record, isEditing);
                    } },
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.save', defaultMessage: 'Save' }) },
                    _react2.default.createElement(_antd.Icon, { type: 'check' })
                  )
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'a',
                  { onClick: function onClick() {
                      return _this2.cancelEditRule(record.id);
                    } },
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.cancel', defaultMessage: 'Cancel' }) },
                    _react2.default.createElement(_antd.Icon, { type: 'close' })
                  )
                )
              )
            );
          }
          var editLogicLink = _this2.props.isPackage ? '/automation_engine/' + ruleSetId + '/builder/' + record.id : '/automation_engine/rule_sets/' + ruleSetId + '/builder/' + record.id;

          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: editLogicLink },
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.edit_logic', defaultMessage: 'Go to Rule Builder' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'export' })
                )
              )
            ),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.editRule(record.id);
                  } },
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.edit', defaultMessage: 'Edit Settings' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'edit' })
                )
              )
            ),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.props.rulesActions('duplicate', record.id);
                  } },
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.duplicateRule', defaultMessage: 'Duplicate' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'copy' })
                )
              )
            ),
            _react2.default.createElement(
              _antd.Popconfirm,
              {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.delete.popconfirm', defaultMessage: 'Delete this Rule?' }),
                onConfirm: function onConfirm() {
                  return _this2.props.rulesActions('delete', { id: record.id, rulesetId: _this2.props.record.id });
                }
              },
              _react2.default.createElement(
                'a',
                null,
                _react2.default.createElement(
                  _antd.Tooltip,
                  { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.table.actions.column.delete', defaultMessage: 'Delete' }) },
                  _react2.default.createElement(_antd.Icon, { type: 'delete' })
                )
              )
            )
          );
        }
      }];
      var ruleDescription = this.state.descriptionModalRecord ? this.state.descriptionModalRecord.description : '';
      var newRuleLink = this.props.isPackage ? '/automation_engine/' + ruleSetId + '/builder' : '/automation_engine/rule_sets/' + ruleSetId + '/builder';
      var ruleId = this.state.descriptionModalRecord ? this.state.descriptionModalRecord.id : '';
      return _react2.default.createElement(
        'div',
        { className: 'rulesetExpanded__component' },
        _react2.default.createElement(
          'div',
          { className: 'header-row' },
          _react2.default.createElement(
            _antd.Button,
            { type: 'primary' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: newRuleLink },
              'Add Rule'
            )
          )
        ),
        _react2.default.createElement(_antd.Table, {
          size: 'default',
          rowKey: 'id',
          bordered: false,
          loading: this.props.record.loadingRules,
          columns: columns,
          dataSource: this.props.record.rulesData,
          pagination: false
        }),
        _react2.default.createElement(
          _antd.Modal,
          {
            title: this.props.record.name + ' > ' + (this.state.descriptionModalRecord ? this.state.descriptionModalRecord.name : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.descriptionModal.empty.description', defaultMessage: 'Rule description not available' })),
            visible: this.state.descriptionModalVisible,
            width: 800,
            onCancel: this.toggleDescriptionModal,
            footer: [_react2.default.createElement(
              _antd.Button,
              { key: 'edit-rule', onClick: function onClick() {
                  return _reactRouter.hashHistory.push(newRuleLink + '/' + ruleId);
                } },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.descriptionModal.editRule.button', defaultMessage: 'Edit Rule' })
            ), _react2.default.createElement(
              _antd.Button,
              { type: 'primary', key: 'done', onClick: this.toggleDescriptionModal },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rulesetExpanded.descriptionModal.done.button', defaultMessage: 'Done' })
            )]
          },
          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: ruleDescription } })
        )
      );
    }
  }]);
  return RulesetExpanded;
}(_react.Component), _class.propTypes = {
  fetchingTimezones: _propTypes2.default.bool.isRequired,
  metaTimezones: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  isPackage: _propTypes2.default.bool.isRequired,
  rulesActions: _propTypes2.default.func.isRequired,
  record: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    timezone: _propTypes2.default.string.isRequired,
    loadingRules: _propTypes2.default.bool,
    rulesData: _propTypes2.default.arrayOf(_propTypes2.default.object),
    name: _propTypes2.default.string.isRequired,
    startTime: _propTypes2.default.string.isRequired,
    endTime: _propTypes2.default.string.isRequired
  }).isRequired,
  savingRuleId: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  frequencies: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp);
exports.default = RulesetExpanded;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/components/RulesetExpanded.js
// module id = 3687
// module chunks = 3